import React from "react";

import FlatButton from "../FlatButton";
import ApMarker from "./ApMarker";
import ApDisplayImage from "./ApDisplayImage";
import ApDisplayPdf from "./ApDisplayPdf";

class ApMediaDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDragging: false,
      zoomLevel: 0.5,
      zoomOffset: { x: 0, y: 0 },
      lastPosition: { x: 0, y: 0 },
      isTransforming: false,
      cursor: { isInsideDisplay: false, relPosition: { x: 0, y: 0 } }
    };

    this.displayRef = React.createRef();
  }

  resetDisplay() {
    this.props.setLines(false);
    this.setState({
      zoomLevel: 0.5,
      zoomOffset: { x: 0, y: 0 },
      isTransforming: true
    });
  }

  onZoom(e) {
    if (this.props.editMode !== "view") return;

    let newZoom = this.state.zoomLevel;
    if (e.deltaY < 0) {
      newZoom += 0.1;
    } else {
      newZoom -= 0.1;
    }

    if (newZoom > 0.2 && newZoom <= 2) {
      this.props.setLines(false);
      this.setState({
        zoomLevel: newZoom,
        isTransforming: true
      });
    }
  }

  onStartDrag() {
    if (this.props.editMode !== "view") return;

    this.props.setLines(false);
    this.setState({
      isDragging: true,
      lastPosition: { x: this.props.position.x, y: this.props.position.y }
    });
  }

  onDrag() {
    if (this.props.editMode !== "view") {
      const display = this.displayRef.current.getBoundingClientRect();
      const cursor = this.props.position;
      const localPosition = {
        x: cursor.x - display.x,
        y: cursor.y - display.y
      };

      const relativePosition = {
        x: (localPosition.x / display.width) * 100,
        y: (localPosition.y / display.height) * 100
      };

      const isInside =
        relativePosition.x >= 0 &&
        relativePosition.y >= 0 &&
        relativePosition.x <= 100 &&
        relativePosition.y <= 100;

      this.setState({
        cursor: { relPosition: relativePosition, isInsideDisplay: isInside }
      });
      return;
    }

    if (this.state.isDragging) {
      const delta = {
        x: this.props.position.x - this.state.lastPosition.x,
        y: this.props.position.y - this.state.lastPosition.y
      };

      let newZoomOffset = this.state.zoomOffset;
      newZoomOffset.x += delta.x;
      newZoomOffset.y += delta.y;

      this.setState({
        zoomOffset: newZoomOffset,
        lastPosition: { x: this.props.position.x, y: this.props.position.y },
        isTransforming: true
      });
    }
  }

  cancelDrag() {
    if (this.props.editMode !== "view") return;

    this.setState({ isDragging: false });
  }

  componentWillReceiveProps(props, state) {
    if (this.props.media.source !== props.media.source) {
      this.resetDisplay();
      this.props.setLines(true);
    }
  }

  componentDidUpdate() {
    if (this.state.dirty) {
      this.setState({ dirty: false });
      this.props.onForceUpdate();
    }
  }

  render() {
    const posTop = `calc(50% + ${this.state.zoomOffset.y}px)`;
    const posLeft = `calc(50% + ${this.state.zoomOffset.x}px)`;
    const transform = `translate(-50%, -50%) scale(${
      this.state.zoomLevel
    }) rotateZ(${this.props.rotation}deg)`;

    const imgId = this.state.isDragging ? "Active" : "";

    const markers = this.props.annotations.map((value, index) => {
      if (!value || !value.marker) return null;
      return (
        <ApMarker
          key={value.id}
          mode={
            this.props.annotationStates[index] ? "view_highlighted" : "default"
          }
          position={value.marker.position[0]}
          onUpdate={ref => this.props.onMarkerCreated(index, ref)}
        />
      );
    });

    let cursor = "grab";
    switch (this.props.editMode) {
      case "annotation":
        cursor = "copy";
        break;
      case "draw":
      case "boxselect":
        cursor = "crosshair";
        break;
      default:
        cursor = "move";
    }

    const relPos = this.state.cursor.relPosition;

    return (
      <div
        className="ApMediaDisplay"
        onMouseLeave={() => this.cancelDrag()}
        onMouseUp={() => this.cancelDrag()}
        onMouseMove={() => this.onDrag()}
      >
        <FlatButton
          className="ApMediaDisplayResetBtn"
          label="Bild zentrieren"
          onClick={() => this.resetDisplay()}
        />
        <div
          ref={this.displayRef}
          id={imgId}
          className="Display"
          draggable={false}
          onWheel={e => this.onZoom(e)}
          onMouseDown={() => this.onStartDrag()}
          onMouseUp={() => this.cancelDrag()}
          onDoubleClick={() => {
            if (this.props.editMode === "view") this.resetDisplay();
          }}
          onTransitionEnd={() => {
            if (!this.state.isDragging) this.props.setLines(true);
          }}
          style={{
            top: posTop,
            left: posLeft,
            cursor: cursor,
            transform: transform
          }}
        >
          {this.props.media.type === "pdf" ? (
            <ApDisplayPdf
              file={this.props.media.source}
              requestUpdate={() => this.props.onForceUpdate()}
            />
          ) : (
            <ApDisplayImage file={this.props.media.source} />
          )}

          {markers}

          {/* Display Marker under Cursor in Annotation Mode */}
          {this.props.editMode === "annotation" ? (
            <ApMarker
              mode={
                this.state.cursor.isInsideDisplay
                  ? "edit_inside"
                  : "edit_outside"
              }
              position={relPos}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default ApMediaDisplay;



// WEBPACK FOOTER //
// ./src/components/approval/ApMediaDisplay.js